import React from 'react';
import { useNavigate } from 'react-router-dom';
import { UTILITY_IMAGES } from '../utils/storage';
import './HomeScreen.css';

interface AppItem {
  id: string;
  name: string;
  icon: string;
  color: string;
  route: string;
}

export function HomeScreen() {
  const navigate = useNavigate();

  const apps: AppItem[] = [
    {
      id: 'wizard',
      name: 'New',
      icon: UTILITY_IMAGES.camera,
      color: '#b77dee', // Purple camera
      route: '/wizard',
    },
    {
      id: 'calendar',
      name: 'Calendar',
      icon: UTILITY_IMAGES.calendar,
      color: '#f7cd67', // Yellow calendar
      route: '/calendar',
    },
    {
      id: 'map',
      name: 'Map',
      icon: UTILITY_IMAGES.map,
      color: '#fc736d', // Red map
      route: '/map',
    },
    {
      id: 'stats',
      name: 'Journey',
      icon: UTILITY_IMAGES.leaf,
      color: '#8ac68a', // Green leaf
      route: '/stats',
    },
    {
      id: 'instructions',
      name: 'Kit Info',
      icon: UTILITY_IMAGES.instructions,
      color: '#ecdcb9', // Warm solid cream
      route: '/instructions',
    },
  ];

  // Get current date representation
  const today = new Date();
  const options: Intl.DateTimeFormatOptions = { weekday: 'short', month: 'short', day: 'numeric' };
  const dateString = today.toLocaleDateString('en-US', options);

  return (
    <div className="home-screen-container">
      {/* Wave Background Pattern */}
      <div className="home-screen-waves"></div>

      {/* Date Header Widget */}
      <div className="nook-date-widget">
        <div className="nook-date-text">{dateString}</div>
        <div className="nook-welcome-text">Explore your food journey!</div>
      </div>

      {/* 2x2 App Grid */}
      <div className="nook-apps-grid">
        {apps.map((app) => (
          <div 
            key={app.id} 
            className="nook-app-wrapper"
            onClick={() => navigate(app.route)}
          >
            <div 
              className="nook-app-icon-bg"
              style={{ backgroundColor: app.color }}
            >
              <img 
                src={app.icon} 
                alt={app.name} 
                className="nook-app-icon-img"
              />
            </div>
            <span className="nook-app-name">{app.name}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
export default HomeScreen;
